import React from 'react'
import Header from './header'
import Footer from './footer'
import { Outlet } from "react-router-dom";

import SEO from '../SEO/SEO';
import PageTitle from '../SEO/PageTitle';
import AnnouncementBar from '../announcement/AnnouncementBar';

const Layout = () => {
  return (
    <>
      <PageTitle />
      <SEO />
      <div className="site-sticky-top">
        <AnnouncementBar />
        <Header/>
      </div>
      <Outlet /> 
      <Footer/>
    </>
  )
}

export default Layout